import type { ActionRow, QuickWin } from "@shared/site-audit-report-view";
import { PresentedCopy } from "./presented-text";

export function ActionList({ actions, quickWins }: { actions: ActionRow[]; quickWins: QuickWin[] }) {
  if (actions.length === 0 && quickWins.length === 0) return null;
  return (
    <div className="space-y-4">
      {actions.length > 0 ? (
        <ul className="space-y-3">
          {actions.map((row, index) => (
            <li key={`${row.priority}-${index}`} className="border-t border-border pt-3">
              <div className="flex flex-wrap items-baseline gap-2">
                <span className="rounded-full border border-border px-2 py-0.5 text-xs font-semibold">
                  {row.priority || "Priority"}
                </span>
                <PresentedCopy value={row.finding} className="text-sm font-medium" inline />
              </div>
              <PresentedCopy value={row.action} className="mt-1 text-sm leading-relaxed" />
              {row.impact ? <p className="mt-1 text-xs text-foreground/75">Impact: {row.impact}</p> : null}
            </li>
          ))}
        </ul>
      ) : null}
      {quickWins.length > 0 ? (
        <div className="space-y-3">
          <h3 className="text-sm font-semibold">Low effort</h3>
          <ul className="space-y-3">
            {quickWins.map((row, index) => (
              <li key={`win-${index}`} className="border-t border-border pt-3">
                <PresentedCopy value={row.action} className="text-sm font-medium" />
                <PresentedCopy value={row.impact} className="mt-1 text-sm text-foreground/75" />
                {row.effort ? (
                  <p className="mt-1 text-xs text-foreground/75">{row.effort} effort</p>
                ) : null}
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
}
